<template>
  <div v-loading="loading">
    <div class="flex justify-end">
      <base-button
        text="New Loyalty"
        background="bg-darkBlue"
        @click="isLoyaltySchemeModal = true"
      />
    </div>
    <div class="table-wrapper mt-0" id="table-wrapper">
      <table class="custom-table responsive-table border-seperate mt-0">
        <thead>
          <tr>
            <!-- <th>
              <base-checkbox />
            </th> -->
            <th>LOYALTY NAME</th>
            <th>DISCOUNT RATE (%)</th>
            <th>DATE ADDED</th>
            <th class="actions relative">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="cursor-pointer"
            v-for="scheme in loyaltySchemes"
            :key="scheme.id"
          >
            <!-- <td>
              <base-checkbox />
            </td> -->
            <td>{{ scheme.loyaltyCategory }}</td>
            <td>{{ scheme.discountRate }}</td>
            <td>{{ scheme.createdAt | formatDate }}</td>

            <td
              class="relative flex justify-center"
              tabindex="-1"
              @blur="selectedRowId = null"
            >
              <span
                @click="
                  selectedRowId
                    ? (selectedRowId = null)
                    : (selectedRowId = scheme.id)
                "
                ><vertical-ellipsis
              /></span>
              <action-popup width="w-48" v-if="selectedRowId == scheme.id">
                <div>
                  <!-- <p class="py-1" @click="editLoyaltyScheme(scheme)">
                    Edit
                  </p> -->
                  <p class="py-1" @click="deleteLoyaltyScheme(scheme.id)">
                    Delete
                  </p>
                </div>
              </action-popup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <loyalty-scheme-form
      :show-modal="isLoyaltySchemeModal"
      @close-modal="isLoyaltySchemeModal = false"
      @scheme-created="getAllLoyaltySchemes"
    />
  </div>
</template>

<script>
import LoyaltySchemeForm from "@/components/3pl/CRM/CustomerRegistration/Modals/CreateLoyaltyScheme";

export default {
  name: "loyalties",
  components: {
    LoyaltySchemeForm,
  },
  data() {
    return {
      selectedRowId: null,
      loyaltySchemes: [],
      isLoyaltySchemeModal: false,
      loading: false,
    };
  },
  mounted() {
    this.getAllLoyaltySchemes();
  },
  methods: {
    async getAllLoyaltySchemes() {
      this.loading = true;
      try {
        const response = await this.$_getAllLoyaltySchemes();
        this.logResponse(response);
        this.loyaltySchemes = response.data;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async deleteLoyaltyScheme(id) {
      this.generateToast("Deleting loyalty scheme!", "success");
      try {
        const response = await this.$_deleteLoyaltyScheme(id);
        this.logResponse(response);
        // this.loyaltySchemes = response.data;
        this.generateToast("Loyalty scheme deleted!", "success");
        this.getAllLoyaltySchemes();
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
td,
th {
  padding: 1rem 2rem;
}
.actions {
  width: 3rem;
}
</style>
